import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { NavigationDataService } from './navigation-data.service';

let DataId = 1;

@Injectable({
    providedIn: 'root',
})
export class DialogLinkService {
    constructor(
        private router: Router,
        private navigationData: NavigationDataService
    ) {}

    open(dialogCommands: (string | number)[], ev?: Event, queryParams?: Params) {
        let outlet = 'd';

        // find the best available outlet for this dialog
        // TODO: automatically determine which dialogs are modal and which are not
        const ModalDialogs = ['tx', 'notes'];
        const isModal = ModalDialogs.includes(`${dialogCommands[0]}`);
        if (isModal) {
            // modals always replace other modals
            outlet = 'd';
        } else {
            // non-modals get any available outlet
            const outletRoutes = this.router.routerState.root.children.filter(
                (c) => c.outlet === 'd' || c.outlet === 'd2'
            );
            for (const route of outletRoutes) {
                if (route.snapshot.routeConfig.path === dialogCommands[0]) {
                    outlet = route.outlet;
                    break;
                } else {
                    outlet = 'd2';
                }
            }
        }

        // mouse click event is used for positioning of the dialog
        const dataId = `${++DataId}`;
        this.navigationData.pushNavigationData(dataId, { ev });

        // do navigate
        const cmd = [
            '',
            {
                outlets: {
                    [outlet]: dialogCommands,
                    ...(isModal ? { d2: null } : {}),
                },
            },
        ];
        this.router.navigate(cmd, { queryParams, queryParamsHandling: 'merge', state: { dataId } });
    }
}
